import React from "react";

import { SnackbarProvider } from "igfd-commons/src/snackbar";

import { ErrorInformer } from "@dashboard/components/errors/ErrorInformer";

export const DashboardSnackbarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <SnackbarProvider>
    {children}
    {/* This component shows errors from the Redux store */}
    <ErrorInformer />
  </SnackbarProvider>
);
